var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDialog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 247,
    viewBox: "0 0 309 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.73537,
    y: 23.1611,
    width: 292.906,
    height: 167.606,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5378,
    y: 5.79883,
    width: 266.273,
    height: 27.8378,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0936,
    y: 8.50684,
    width: 11.1385,
    height: 27.8378,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8994,
    y: 17.167,
    width: 11.1385,
    height: 27.8378,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0975,
    y: 166.265,
    width: 11.1385,
    height: 27.8378,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 128.387,
    y: 199.778,
    width: 11.1385,
    height: 37.0132,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 135.853,
    y: 191.271,
    width: 11.1385,
    height: 37.0132,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 142.297,
    y: 175.597,
    width: 11.1385,
    height: 37.0132,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 284.826,
    y: 17.0127,
    width: 11.1385,
    height: 27.8378,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 282.339,
    y: 172.065,
    width: 11.1385,
    height: 27.8378,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1757,
    y: 177.479,
    width: 267.858,
    height: 27.8378,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.68 204.311L126.516 204.311L126.516 238.491L132.68 238.491L132.68 204.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.844 238.493L132.68 238.493L132.68 247L138.844 247L138.844 238.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12 229.83L138.956 229.83L138.956 238.337L145.12 238.337L145.12 229.83Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.284 221.322L145.12 221.322L145.12 229.829L151.284 229.829L151.284 221.322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.448 212.817L151.284 212.817L151.284 221.324L157.448 221.324L157.448 212.817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.497 204.311L120.333 204.311L120.333 212.817L126.497 212.817L126.497 204.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.396 204.311L150.118 204.311L150.118 212.817L290.396 212.817L290.396 204.311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.783 204.31L30.8357 204.31L30.8357 212.816L128.783 212.816L128.783 204.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.396 1.5449L22.5378 1.54492L22.5378 10.0515L290.396 10.0515L290.396 1.5449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 27.2178L302.836 27.2178L302.836 187.141L309 187.141L309 27.2178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.56 10.0518L290.396 10.0518L290.396 18.5583L296.56 18.5583L296.56 10.0518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.724 18.7148L296.56 18.7148L296.56 27.2214L302.724 27.2214L302.724 18.7148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.56 195.649L290.396 195.649L290.396 204.156L296.56 204.156L296.56 195.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.724 187.143L296.56 187.143L296.56 195.649L302.724 195.649L302.724 187.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0975 27.2178L3.93346 27.2178L3.93347 187.141L10.0976 187.141L10.0975 27.2178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5379 10.0527L16.3738 10.0527L16.3738 18.5593L22.5379 18.5593L22.5379 10.0527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2616 18.7148L10.0975 18.7148L10.0975 27.2214L16.2616 27.2214L16.2616 18.7148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5379 195.649L16.3738 195.649L16.3738 204.156L22.5379 204.156L22.5379 195.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2616 187.142L10.0975 187.142L10.0975 195.648L16.2616 195.648L16.2616 187.142Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.317 202.763L123.153 202.763L123.153 236.944L129.317 236.944L129.317 202.763Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.482 236.943L129.317 236.943L129.317 245.45L135.482 245.45L135.482 236.943Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.758 228.282L135.594 228.282L135.594 236.789L141.758 236.789L141.758 228.282Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.922 219.777L141.758 219.777L141.758 228.284L147.922 228.284L147.922 219.777Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.086 211.269L147.922 211.269L147.922 219.775L154.086 219.775L154.086 211.269Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.135 202.763L116.971 202.763L116.971 211.269L123.135 211.269L123.135 202.763Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.199 202.766L147.922 202.766L147.922 211.272L288.199 211.272L288.199 202.766Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.123 202.765L19.1757 202.765L19.1757 211.271L117.123 211.271L117.123 202.765Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M287.033 -2.34455e-05L19.1756 0L19.1756 8.50656L287.033 8.50653L287.033 -2.34455e-05Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.638 25.6738L299.474 25.6738L299.474 185.597L305.638 185.597L305.638 25.6738Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M293.197 8.50684L287.033 8.50684L287.033 17.0134L293.197 17.0134L293.197 8.50684Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M299.362 17.1699L293.197 17.1699L293.197 25.6765L299.362 25.6765L299.362 17.1699Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M293.197 194.104L287.033 194.104L287.033 202.611L293.197 202.611L293.197 194.104Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.362 185.599L293.197 185.599L293.197 194.105L299.362 194.105L299.362 185.599Z",
    fill: "#231F20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73538 25.6738L0.571289 25.6738L0.571303 185.597L6.73539 185.597L6.73538 25.6738Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1756 8.50781L13.0115 8.50781L13.0115 17.0144L19.1756 17.0144L19.1756 8.50781Z",
    fill: "#231F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 17.1699L6.73537 17.1699L6.73537 25.6765L12.8995 25.6765L12.8995 17.1699Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1756 194.104L13.0115 194.104L13.0115 202.611L19.1756 202.611L19.1756 194.104Z",
    fill: "#231F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8995 185.599L6.73537 185.599L6.73537 194.105L12.8995 194.105L12.8995 185.599Z",
    fill: "#231F20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/dialog.83a2a615d7fdca8431d0c9db5d0fc293.svg";
export { ForwardRef as ReactComponent };